<div class="h-100 d-flex flex-column">
  <div class="container-fluid flex-grow p-0 m-0" style="position: absolute">
    <app-header [helpToggled]="helpToggled" (helpToggledChange)="onHelpToggledChange($event)" class="custom-header"></app-header>
        <div class="container">
          <router-outlet></router-outlet>
        </div>
  </div>
</div>

<help-modal *ngIf="helpToggled" (close)="onHelpToggledChange(false)"></help-modal>